// @flow
const fonts = {
  mainFont: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  serif: 'PT Serif',
  mono: 'PT Mono',
};

export default fonts;
